// Set of utility functions to handle keyboard events to simplify the code
// and make it more readable. These functions are used to handle keyboard events
// by converting them into click events. This is useful for accessibility
// purposes, allowing users to trigger click events using the keyboard.
const clickOnKeyboardEvent = (event: React.KeyboardEvent) => {
  event.preventDefault()
  if (event.currentTarget instanceof HTMLElement) {
    event.currentTarget.click()
  }
}

type ClickOnKeyboardEvent = (event: React.KeyboardEvent) => void

export const clickOnEnter: ClickOnKeyboardEvent = (
  event: React.KeyboardEvent
) => {
  if (event.key === 'Enter') clickOnKeyboardEvent(event)
}

export const clickOnSpace: ClickOnKeyboardEvent = (
  event: React.KeyboardEvent
) => {
  if (event.key === ' ') clickOnKeyboardEvent(event)
}

export const composeClickHandlers = (...handlers: ClickOnKeyboardEvent[]) => {
  return (event: React.KeyboardEvent) => {
    handlers.forEach((handler) => handler(event))
  }
}
